/* Drop visuals. The active drop shows a REAL catalog piece (actual product photo);
   upcoming drops keep teaser visuals until their stock is photographed. */
export const DROP_IMGS = {
  strom_shells: "/api/files/zejzen/products/TNF05/117dc635834c_1600.webp",
  fleece: "/api/files/zejzen/drops/patagonia-fleece.webp",
  aran: "/api/files/zejzen/drops/aran-fisherman-knit.webp",
};

/* natural pixel dims — used for width/height attrs so drop heroes never shift layout */
export const DROP_IMG_DIMS = {
  strom_shells: { width: 1200, height: 1600 },
  fleece: { width: 578, height: 682 },
  aran: { width: 665, height: 747 },
};
